/**
*   Wrapper for vuejs-datepicker that adds the id of the entity as an additional parameter in the events' callbacks
**/

<template>
    <datepicker :format="format" :language="language" :placeholder="placeholder" :clear-button="clearButton"
                :bootstrap-styling="bootstrapStyling" :calendar-class="calendarClass" input-class="datepicker-input"
                @input="onInput" v-model="date"></datepicker>
</template>

<script>
import Datepicker from 'vuejs-datepicker';

export default {
    name: 'PSDatePicker',
    components: {
        Datepicker
    },
    props: {
        format: {
            type: String,
            default: 'yyyy-MM-dd'
        },
        language: {
            type: Object,
            default: () => null
        },
        placeholder: {
            type: String,
            default: ''
        },
        bootstrapStyling: {
            type: Boolean,
            default: true
        },
        clearButton: {
            type: Boolean,
            default: true
        },
        calendarClass: {
            type: String,
            default: ''
        },
        entity: {
            type: Object,
            default: () => ({ id: 0 })
        },
        field: {
            type: String,
            default: ''
        },
        initialValue: {
            type: String,
            default: ''
        },
        model: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            date: ''
        }
    },
    created() {
        if (this.initialValue !== '') {
            this.date = this.initialValue;
        }
    },
    methods: {
        onInput(value) {
            this.$emit('input-changed', value, this.entity.id, this.field);
        }
    },
    watch: {
        model(value) {
            if (value === '') {
                this.date = '';
            }
        }
    }
}
</script>

<style scoped>

</style>